import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from '../common/spinner';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid from '@mui/material/Grid';
import AccordionDetails from '@mui/material/AccordionDetails';
import Accordion from '@mui/material/Accordion';
import ProductionOrderView from '../order/productionorderview';
import User from '../domain/user';
import { getOrdersByOrderNumber } from '../modules/orderdata';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import moment from 'moment';
import { includes } from 'lodash';
import { getOrderDisplayNumber } from '../domain/order';

export default function SearchResultsOrderDetails(props) {
    const customerUi = process.env.REACT_APP_TARGET === 'customerui';
    const dispatch = useDispatch();
    const ordersByOrderNumber = useSelector((state) => state.orderdata.ordersByOrderNumber);
    const userprofile = useSelector((state) => state.authentication.userProfile);
    const portfolios = useSelector((state) => state.portfoliodata.portfolioDescriptions);
    const ordersFull = ordersByOrderNumber[props.order.orderNumber];
    const [expanded, setExpanded] = useState(false);
    const [portfolio, setPortfolio] = useState({});
    const order = props.order;
    const allowPricing = customerUi ? includes(userprofile.roles, User.RoleAllowPricing()) : true;

    useEffect(() => {
        if (ordersFull && portfolios && portfolios.length > 0) {
            setPortfolio(portfolios.find((p) => p.id === ordersFull[0].portfolioId));
        }
    }, [ordersFull, portfolios]);

    const onExpand = () => {
        setExpanded(!expanded);
        if (!ordersFull) dispatch(getOrdersByOrderNumber(order.orderNumber));
    };

    const openOrder = (event) => {
        props.history.push('/ordernumber/' + order.orderNumber);
        event.stopPropagation();
    };

    return (
        <React.Fragment>
            <Accordion expanded={expanded} onChange={onExpand}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Grid container direction="row" alignItems="center">
                        <Grid item>
                            <OpenInNewIcon onClick={(event) => openOrder(event)} />
                        </Grid>
                        <Grid item>
                            {moment(order.orderSent).format('DD.MM.YYYY HH:mm')}&nbsp;&nbsp;&nbsp;
                            {getOrderDisplayNumber(order)}&nbsp;
                            {order.location.name}
                        </Grid>
                    </Grid>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid item>
                        {ordersFull && (
                            <ProductionOrderView
                                orders={ordersFull}
                                allowPricing={allowPricing}
                                portfolio={portfolio}
                                customerUi={customerUi}
                            />
                        )}
                        {!ordersFull && <Spinner />}
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </React.Fragment>
    );
}
